import RootController from './root/root.controller'

const module = angular.module('ac.controllers', [])

module.controller('RootController', RootController)

export default module.name
